import { Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';

@Component({
  selector: 'app-dash',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.css']
})
export class DashComponent {
  public lineChartData: ChartDataSets[] = [
  { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
];
public lineChartLabels: Label[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
public lineChartOptions: (ChartOptions) = {
  responsive: true,
};
public lineChartColors: Color[] = [
  {
    borderColor: 'rgba(0,0,50,0.8)',
    backgroundColor: 'rgba(0,0,255,0.3)',
  },
];
public lineChartLegend = false;
public lineChartType = 'line';
public lineChartPlugins = [];
  /** Based on the screen size, switch from standard to one column per row */

  cards = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map(({ matches }) => {
        if(matches){
          return [
            { title: 'Card 1', cols: 3, rows: 1 },
            { title: 'Card 2', cols: 3, rows: 1 },
            { title: 'Card 3', cols: 3, rows: 1 }
          ];
        }

        return [
          { title: 'Card 1', cols: 1, rows: 1 },
          { title: 'Card 2', cols: 1, rows: 1 },
          { title: 'Card 3', cols: 1, rows: 1 }
        ];;


    })
  )

  constructor(private breakpointObserver: BreakpointObserver) {}
}
